import Clipboard from 'clipboard'
import $message from '@/utils/message'
import i18 from '@/utils/I18.js'

let copyFn
export default {
  
  bind(el, binding) {
    copyFn = function() {
      let className = Array.from(el.classList).join('.')
      let text = binding.value.text ? binding.value.text : el.text
      let clipboard = new Clipboard(`.${className}`, {
        text: function () {
          return text
        }
      })
      clipboard.on('success', (e) => {
        $message.success(i18.language('复制成功'))
        clipboard.destroy()
        clipboard = null
      })
      clipboard.on('error', (e) => {
        $message.warning(i18.language('该浏览器不支持复制'))
        clipboard.destroy()
        clipboard = null
      })
    }
    el.addEventListener("click", copyFn, false);
  },
  unbind (el) {
    if(el) el.removeEventListener('click', copyFn);
  }
}